import { searchShowOnMapClick } from 'analytics/eventDefinitions'
import { addGTMEvent } from 'api/googleTagManager'
import TextLink from 'components/Luxkit/TextLink'
import BodyText from 'components/Luxkit/Typography/BodyText'
import FormatInlineList from 'components/utils/Formatters/FormatInlineList'
import React, { MouseEventHandler, useCallback } from 'react'
import * as Analytics from 'analytics/analytics'

interface Props {
  locations: Array<string>
  mapUrl?: string
}

function SearchTileRowOverlineLocation({ locations, mapUrl }: Props) {
  const mapViewClick = useCallback<MouseEventHandler<HTMLAnchorElement>>((event) => {
    event.stopPropagation()
    Analytics.trackClientEvent({
      subject: 'show_on_map',
      action: 'clicked',
      type: 'interaction',
      category: 'vertical_page',
    })

    addGTMEvent(searchShowOnMapClick())
  }, [])

  return <BodyText variant="small" colour="neutral-two">
    <FormatInlineList list={locations} type="unit" />
    {!!mapUrl && <>{' '}&middot; <TextLink weight="regular" to={mapUrl} onClick={mapViewClick}>
      Show on map
    </TextLink>
    </>}
  </BodyText>
}

export default SearchTileRowOverlineLocation
